// AvatarSelectionModal.js
import React from 'react';
import './AvatarSelectionModal.css';

const avatars = [
  `${process.env.PUBLIC_URL}/avatar1.jpg`,
  `${process.env.PUBLIC_URL}/cat2.jpg`,
  `${process.env.PUBLIC_URL}/Peacock.jpg`,
  `${process.env.PUBLIC_URL}/Dog.jpg`,
  `${process.env.PUBLIC_URL}/Horse.jpg`,
];

const AvatarSelectionModal = ({ show, onClose, onSelectAvatar }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="avatar-modal-overlay show">
      <div className="avatar-modal-content show">
        <button className="avatar-modal-close" onClick={onClose}>
        &times;
        </button>
        <h2>Choose your Angel</h2>
        <div className="avatar-selection">
          {avatars.map((avatar, index) => (
            <img
              key={index}
              src={avatar}
              alt={`Avatar ${index + 1}`}
              className="avatar-option"
              onClick={() => onSelectAvatar(avatar)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AvatarSelectionModal;